import { CssBaseline, createTheme, ThemeProvider } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import {
	BrowserRouter,
	Navigate,
	Route,
	Routes,
	useNavigate,
} from "react-router-dom";
import EventsListView from "./views/eventslist";
import LoginView from "./views/login";
import OutstandingPaymentsView from "./views/outstanding-payments";
import ParticipationView from "./views/participation";
import PaymentsImportView from "./views/payments-import";
import ResetPasswordView from "./views/reset-password";

const theme = createTheme({
	palette: {
		primary: {
			main: "#0c5a71ff",
		},
		secondary: {
			main: "#2f9e7b",
		},
	},
});

function AppRoutes() {
	const navigate = useNavigate();
	return (
		<Routes>
			<Route
				path="/"
				element={<LoginView onAuthSuccess={() => navigate("/events")} />}
			/>
			<Route path="/events" element={<EventsListView />} />
			<Route path="/participation/:eventId" element={<ParticipationView />} />
			<Route path="/payments-import" element={<PaymentsImportView />} />
			<Route
				path="/outstanding-payments"
				element={<OutstandingPaymentsView />}
			/>
			<Route path="/reset-password" element={<ResetPasswordView />} />
			<Route path="*" element={<Navigate to="/" replace />} />
		</Routes>
	);
}

function App() {
	return (
		<BrowserRouter
			future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
		>
			<AppRoutes />
		</BrowserRouter>
	);
}

const rootEl = document.getElementById("root");
if (!rootEl) {
	const el = document.createElement("div");
	el.id = "root";
	document.body.appendChild(el);
}

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<App />
			</ThemeProvider>
		</QueryClientProvider>
	</React.StrictMode>,
);
